import { ErrorNotification } from '@sleepstation/components'
import { paddingTop } from '@sleepstation/style-api-helpers'
import { constrainNarrow } from '@sleepstation/style-mixins'
import React, { useContext } from 'react'
import styled from 'styled-components'
import RoutingContext from '../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const TITLE = `We’ve experienced a problem loading this page`
const BODY = `We’ve notified our developers about this problem and they’ll work to resolve it ASAP. If you need any more help, just send us a message and our team will be able to help.`
const LINK_LABEL = `Send us a message`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  ${paddingTop([1])}
  ${constrainNarrow()}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TopLevelErrorNotification = ({ ...props }) => {
  const { appRouting } = useContext(RoutingContext)
  const linkUrl = appRouting.chatMessagesPath

  return (
    <Layout>
      <ErrorNotification
        title={TITLE}
        body={BODY}
        linkLabel={LINK_LABEL}
        linkUrl={linkUrl}
        {...props}
      />
    </Layout>
  )
}

export default TopLevelErrorNotification
